import { LoyaltyRewardMiniCardVariant } from "./types";
import useTranslate from "../../../hooks/useTranslate";

export const ContentLoyaltyRewardMiniCard = (
  t: ReturnType<typeof useTranslate>,
) => ({
  [LoyaltyRewardMiniCardVariant.NOMINAL]: {
    title: "+ {{value}} {{currency}}",
    descriptionActive: "loyalty.redesign.1.nominal.subtitle",
  },
  [LoyaltyRewardMiniCardVariant.FREE_SPINS]: {
    title: "loyalty.redesign.1.freespins.title",
    descriptionActive: "loyalty.redesign.1.freespins.subtitle",
  },
  [LoyaltyRewardMiniCardVariant.CASHBACK_DAILY]: {
    title: "loyalty.redesign.1.cashback-daily.title",
    descriptionActive: "loyalty.redesign.1.cashback-daily.subtitle",
  },
  [LoyaltyRewardMiniCardVariant.CASHBACK_WEEKLY]: {
    title: "loyalty.redesign.1.cashback-weekly.title",
    descriptionActive: "loyalty.redesign.1.cashback-weekly.subtitle",
  },
  [LoyaltyRewardMiniCardVariant.CASHBACK_MONTHLY]: {
    title: "loyalty.redesign.1.cashback-monthly.title",
    descriptionActive: "loyalty.redesign.1.cashback-monthly.subtitle",
  },
  [LoyaltyRewardMiniCardVariant.MASCOT]: {
    title: "loyalty.redesign.1.mascot.title",
    descriptionActive: "loyalty.redesign.1.mascot.description",
  },
  [LoyaltyRewardMiniCardVariant.BOOSTER]: {
    title: `${t("loyalty.redesign.1.card-mini.booster.title")} {{value}}`,
    descriptionActive: "loyalty.redesign.1.card-mini.booster.description",
  },
});
